
            <!-- collect fee single member single month -->
            <!-- collect fee single member multi month -->

<div id="invoice" style="display: none;">

  <div class="invoice-box" style="padding: 0px !important;  width: 63mm; max-width: 63mm; margin: 0 !important;" *ngFor="let member of printInvoiceMembers; let memberIndex = index">
    <div style="width: 60mm;max-width: 60mm; padding:5px;">
      <div style="display: flex; justify-content: space-around; width: 100%;">
        <ng-container *ngIf="invoiceData.bannerImage.length === 1">
            <!-- Display single image centered -->
            <img [src]="config.Server + 'assets/layout/images/companies/' + invoiceData.bannerImage[0]?.image"
                onerror="this.src='assets/layout/images/logoCompany.png'"
                alt="Company Logo" style="
                max-width: 100%;
                margin-top: 30px;
                margin-bottom: 20px;
                max-height: 150px;"
            />
        </ng-container>

        <ng-container *ngIf="invoiceData.bannerImage.length > 1">
            <!-- Display multiple images side by side -->
            <img *ngFor="let banner of invoiceData.bannerImage"
                [src]="config.Server + 'assets/layout/images/companies/' + banner.image"
                onerror="this.src='assets/layout/images/logoCompany.png'"
                alt="Company Logo" style="
                width: 48%; /* Adjust width to fit two images side by side */
                margin-top: 30px;
                margin-bottom: 20px;
                max-height: 150px;/* Add margin between images */
                "
            />
        </ng-container>

    </div>
            <div style="text-align: center;font-size: 11px;line-height: 14px; color: black;">{{invoiceData.name}}</div>
            <div style="text-align: center;font-size: 11px;line-height: 14px; color: black;">{{invoiceData.address}}</div>
            <div *ngIf="invoiceData.contact.length === 1" style="
                text-align: center;
                font-size: 11px;
                line-height: 15px;
                color: black;
            ">
                {{ invoiceData.contact[0].contactNumber }}
            </div>

            <div *ngIf="invoiceData.contact.length > 1" style="

                text-align: center;
                font-size: 11px;
                line-height: 15px;
                color: black;
            ">
                <div *ngFor="let contact of invoiceData.contact">
                    {{ contact.contactNumber }}
                </div>
            </div>
      <table style="border-collapse: collapse; font-size: 12px; font-size: 9px;border: 1px solid black;line-height: 12px; margin-top: 8px;">
        <tbody>
          <tr>
            <td style="font-size: 10px;text-align: center; padding: 0px; font-weight: bold;">{{setLabel("membership#Label")}}</td>
            <td style="font-size: 10px;text-align: center; padding: 0px;font-weight: bold;">{{setLabel("nameLabel")}}</td>
          </tr>
          <tr>
            <td style="font-size: 10px;text-align: center; padding: 0px;">{{member.tagNumber}}</td>
            <td style="font-size: 10px;text-align: center; padding: 0px;">{{member.name}}</td>
          </tr>
          <tr>
            <td style="font-size: 10px;text-align: center; padding: 0px; font-weight: bold;">Invoice Date</td>
            <td style="font-size: 10px;text-align: center; padding: 0px;font-weight: bold;">Next Renewal Date</td>
          </tr>
          <tr>
            <td style="font-size: 10px;text-align: center; padding: 0px;"> {{fundInvoice.date | date: 'dd/MM/yyyy'}}
            </td>
            <td style="font-size: 10px;text-align: center; padding: 0px;"><span *ngIf="printInvoiceMembers.length > 0">{{printInvoiceMembers[0].settings.dueDate | date: 'dd/MM/yyyy'}}</span></td>
          </tr>
        </tbody>
      </table>
<table
  style="border-collapse: collapse; font-size: 12px; font-size: 9px;border: 1px solid black;line-height: 12px; margin-top: 8px;">
  <tbody>
    <tr *ngIf="invoiceData.showAddedBy && invoiceData.showAddedBy == true">
      <td style="font-size: 10px;text-align: center; padding: 0px; font-weight: bold;">{{setLabel("addedLabel")}}
      </td>
      <td style="font-size: 10px;text-align: center; padding: 0px;">{{user.name}}</td>


    </tr>
  <tr>
      <td style="font-size: 10px;text-align: center; padding: 0px;font-weight: bold;">{{setLabel("packageLabel")}}</td>
      <td style="font-size: 10px;text-align: center; padding: 0px;">{{member.packageName}}</td>
    </tr>
  </tbody>
</table>    
          <table *ngIf="branch.invoiceData?.showCustomerContact" style="border-collapse: collapse; font-size: 12px; font-size: 9px;border: 1px solid black;line-height: 12px; margin-top: 8px;">
            <tbody>
                <tr style="margin-left:1px;">
                    <td style="font-size: 10px;padding: 1px 1px 1px 20px;font-weight: bold; text-align:left;">
                                {{setLabel("showCustomerContactLabel")}}

                    </td>
                    <td style="font-size: 10px;text-align: left;padding: 1px;">
                                {{member.contactDetail?.contact || member.contact}}
                    </td>
                </tr>
            </tbody>
          </table>

                  <table style="border-collapse: collapse; font-size: 12px; font-size: 9px;border: 1px solid black;line-height: 12px; margin-top: 8px;">
                    <tbody>
                        <tr style="margin-left:1px;">
                            <td style="font-size: 10px;padding: 1px 1px 1px 20px;font-weight: bold; text-align:left;">
                                {{setLabel("paymentModeLabel")}}

                            </td>
                            <td style="font-size: 10px;text-align: left;padding: 1px;">
                                {{paymentMode}}
                            </td>
                        </tr>
                    </tbody>
                </table>
   

      <table style="border-collapse: collapse; font-size: 12px; font-size: 9px;margin-top: 3px; line-height: normal;">
        <thead
          style=" text-align: center;font-weight: bold; font-size: 12px; font-size: 9px; background-color: black;color: white;">
          <tr style="background-color: black;color: white; border: 1px solid black;">
            <th style="width: 40px; word-break: break-word; font-size: 10px;">{{setLabel("typeLabel")}}</th>
            <th style="width: 40px; word-break: break-word; font-size: 10px;">{{setLabel("amountLabel")}}</th>
    <th style="width: 40px; word-break: break-word; font-size: 10px;"
    *ngIf="hasDiscount(member)">
  {{setLabel("discountLabel")}}
</th>
            <th style="width: 40px; word-break: break-word; font-size: 10px;" *ngIf="taxType !== 'NO_TAX'" >{{setLabel("taxLabel")}}</th>
          </tr>
        </thead>
        <tbody>
            <tr *ngFor="let feeDetail of member.feeDetails">
              <td style="font-size: 9px;border:1px solid black;text-align: center;">
  {{ feeDetail.status === 'Monthly Fee - Paid' ? 'Package Fee Paid' : feeDetail.status }}
</td>
              <td *ngIf="feeDetail.status == 'Registration Fee - Paid' || feeDetail.status == 'Monthly Fee - Paid' || feeDetail.status == 'Trainer Fee - Paid'"
    style="font-size: 9px;border:1px solid black;text-align: center;">
  {{feeDetail.pay | number:'1.0-0'}}
</td>
           <td *ngIf="(feeDetail.status == 'Registration Fee - Paid' || feeDetail.status == 'Monthly Fee - Paid' || feeDetail.status == 'Trainer Fee - Paid') && hasDiscount(member)"
    style="font-size: 9px;border:1px solid black;text-align: center;">{{feeDetail.discount | number:'1.0-0'}}</td>
              <td *ngIf="(feeDetail.status == 'Registration Fee - Paid' || feeDetail.status == 'Monthly Fee - Paid' || feeDetail.status == 'Trainer Fee - Paid') && taxType !== 'NO_TAX'" style="font-size: 9px;border:1px solid black;text-align: center;" >{{feeDetail.tax | number:'1.0-0'}}</td>
            </tr>
          <tr *ngIf="hasFeeDiscount(member.feeDetails, 'Registration Fee - Paid')">
           <td style="font-size: 10px; text-align: start; font-weight: bold;border-bottom: 1px solid;border-left: 1px solid;"
    [attr.colspan]="hasDiscount(member) ? 3 : 2"
    *ngIf="taxType !== 'NO_TAX'">{{setLabel("discountedRegistrationFeeLabel")}}</td>
<td style="font-size: 10px; text-align: start; font-weight: bold;border-bottom: 1px solid;border-left: 1px solid;"
    [attr.colspan]="hasDiscount(member) ? 2 : 1"
    *ngIf="taxType === 'NO_TAX'">{{setLabel("discountedRegistrationFeeLabel")}}</td>
<td style="font-size: 10px;text-align: center; border-right: 1px solid; border-bottom: 1px solid;">
    {{ getFeeAfterTaxAndDiscount(member,"Registration Fee - Paid") }}
</td>
          </tr>
          <tr *ngIf="hasFeeDiscount(member.feeDetails, 'Monthly Fee - Paid')">
           <td style="font-size: 10px; text-align: start; font-weight: bold;border-bottom: 1px solid;border-left: 1px solid;"
    [attr.colspan]="hasDiscount(member) ? 3 : 2"
    *ngIf="taxType !== 'NO_TAX'">{{setLabel("discountedMonthlyFeeLabel")}}</td>
<td style="font-size: 10px; text-align: start; font-weight: bold;border-bottom: 1px solid;border-left: 1px solid;"
    [attr.colspan]="hasDiscount(member) ? 2 : 1"
    *ngIf="taxType === 'NO_TAX'">{{setLabel("discountedMonthlyFeeLabel")}}</td>
<td style="font-size: 10px;text-align: center; border-right: 1px solid; border-bottom: 1px solid;">
    {{getFeeAfterTaxAndDiscount(member,"Monthly Fee - Paid")}}
</td>
          </tr>
          <!-- <tr>
            <td style="font-size: 10px; text-align: start;  font-weight: bold;border-bottom: 1px solid;border-left: 1px solid; "
            colspan="3"  *ngIf="taxType !== 'NO_TAX'">{{setLabel("discountedTrainerFeeLabel")}}</td>
            <td style="font-size: 10px; text-align: start;  font-weight: bold;border-bottom: 1px solid;border-left: 1px solid; "
            colspan="2"  *ngIf="taxType === 'NO_TAX'">{{setLabel("discountedTrainerFeeLabel")}}</td>
            <td style="font-size: 10px;text-align: center; border-right: 1px solid;
                  border-bottom: 1px solid;">{{getFeeAfterTaxAndDiscount(member,"Trainer Fee - Paid")}}</td>
          </tr> -->
          <tr>
            <td style="font-size: 10px; text-align: start; font-weight: bold; border-left: 1px solid; border-bottom: 1px solid;"
    [attr.colspan]="hasDiscount(member.feeDetails) ? 3 : 2"
    *ngIf="taxType !== 'NO_TAX'">{{setLabel("grandTotalLabel")}}
  <i *ngIf="taxType == 'INCLUDING_TAX'" style="display: block; font-size: 10px; font-style: italic; color: blue;">
    {{setLabel("taxIncludedFeeLabel")}}
  </i>
</td>
<td style="font-size: 10px; text-align: start; font-weight: bold; border-left: 1px solid; border-bottom: 1px solid;"
    [attr.colspan]="hasDiscount(member) ? 2 : 1"
    *ngIf="taxType === 'NO_TAX'">{{setLabel("grandTotalLabel")}}
</td>
<td style="font-size: 10px;text-align: center; border-right: 1px solid; border-bottom: 1px solid;">
    {{getGrandTotalAfterTaxAndDiscount(member)}}
</td>
          </tr>
        </tbody>
      </table>
      <div *ngIf="invoiceMessage"
        style="text-align: center;padding-top: 10px;font-size: 9px;font-family:'Times New Roman';color: black;line-height: 14px;">
        {{invoiceMessage}}
      </div>
      <div *ngIf="branch.permissions?.isAllowSRB"
          style="text-align: center; padding-top: 10px; font-size: 9px; font-family: 'Times New Roman'; color: black; line-height: 14px;">
        
          <div style="text-align: center; padding-top: 6px; font-size: 10px; font-weight: bold; color: black; white-space: nowrap;">
            SRBInvoiceIDs
          </div>

          <div *ngFor="let feeDetail of member.feeDetails">
              {{ feeDetail.SRBInvoiceID }}
          </div>
      </div>
      <app-fbr-receipt-block [items]="memberFbrItems[memberIndex] || []" [logoUrl]="fbrLogoUrl"></app-fbr-receipt-block>
      <div style=" text-align: center;padding-top: 6px; font-size: 10px; font-weight: bold;color: black; white-space: nowrap;">{{setLabel("softwareByTecfolkLabel")}}
      </div>
    </div>
  </div>
</div>
<!-- /////////////////mail//////////////////////// -->
<div id="invoice1" style="display: none;">
<div class="invoice-box" style="padding: 0px !important;  width: 57mm; max-width: 57mm; margin: 0 !important;"
  *ngFor="let member of printInvoiceMembers">
    <table style="border-collapse: collapse; font-size: 12px; font-size: 9px;margin-top: 3px; line-height: normal;">
      <thead
        style=" text-align: center;font-weight: bold; font-size: 12px; font-size: 9px; background-color: black;color: white;">
        <tr style="background-color: black;color: white; border: 1px solid black;">
          <th style="width: 40px; word-break: break-word; font-size: 10px;">{{setLabel("typeLabel")}}</th>
          <th style="width: 40px; word-break: break-word; font-size: 10px;">{{setLabel("amountLabel")}}</th>
          <th style="width: 40px; word-break: break-word; font-size: 10px;" 
    *ngIf="hasDiscount(member.feeDetails)">
  {{setLabel("discountLabel")}}
</th>
          <th style="width: 40px; word-break: break-word; font-size: 10px;" *ngIf="taxType !== 'NO_TAX'">
            {{setLabel("taxLabel")}}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let feeDetail of member.feeDetails">
          <td style="font-size: 9px;border:1px solid black;text-align: center;"> {{feeDetail.status}}</td>
          <td
            *ngIf="feeDetail.status == 'Registration Fee - Paid' || feeDetail.status == 'Monthly Fee - Paid' || feeDetail.status == 'Trainer Fee - Paid'"
            style="font-size: 9px;border:1px solid black;text-align: center;">{{feeDetail.pay}}</td>
          <td *ngIf="(feeDetail.status == 'Registration Fee - Paid' || 
            feeDetail.status == 'Monthly Fee - Paid' || 
            feeDetail.status == 'Trainer Fee - Paid') && 
            hasDiscount(member.feeDetails)" 
    style="font-size: 9px;border:1px solid black;text-align: center;">
  {{feeDetail.discount | number:'1.0-0'}}
</td>
         <td *ngIf="(feeDetail.status == 'Registration Fee - Paid' || feeDetail.status == 'Monthly Fee - Paid' || feeDetail.status == 'Trainer Fee - Paid') && hasDiscount(member.feeDetails)" 
    style="font-size: 9px;border:1px solid black;text-align: center;">
  {{feeDetail.discount | number:'1.0-0'}}
</td>
        </tr>
        <tr>
          <td style="font-size: 10px; text-align: start; font-weight: bold;border-bottom: 1px solid;border-left: 1px solid;"
    [attr.colspan]="hasDiscount(member.feeDetails) ? 3 : 2"
    *ngIf="taxType !== 'NO_TAX'">{{setLabel("discountedRegistrationFeeLabel")}}</td>
<td style="font-size: 10px; text-align: start; font-weight: bold;border-bottom: 1px solid;border-left: 1px solid;"
    [attr.colspan]="hasDiscount(member.feeDetails) ? 2 : 1"
    *ngIf="taxType === 'NO_TAX'">{{setLabel("discountedRegistrationFeeLabel")}}</td>
<td style="font-size: 10px;text-align: center; border-right: 1px solid; border-bottom: 1px solid;">
    {{ getFeeAfterTaxAndDiscount(member,"Registration Fee - Paid") | number:'1.0-0' }}
</td>
        </tr>
        <tr>
       <td style="font-size: 10px; text-align: start; font-weight: bold;border-bottom: 1px solid;border-left: 1px solid;"
    [attr.colspan]="hasDiscount(member.feeDetails) ? 3 : 2"
    *ngIf="taxType !== 'NO_TAX'">{{setLabel("discountedMonthlyFeeLabel")}}</td>
<td style="font-size: 10px; text-align: start; font-weight: bold;border-bottom: 1px solid;border-left: 1px solid;"
    [attr.colspan]="hasDiscount(member.feeDetails) ? 2 : 1"
    *ngIf="taxType === 'NO_TAX'">{{setLabel("discountedMonthlyFeeLabel")}}</td>
<td style="font-size: 10px;text-align: center; border-right: 1px solid; border-bottom: 1px solid;">
    {{getFeeAfterTaxAndDiscount(member,"Monthly Fee - Paid") | number:'1.0-0'}}
</td>
        </tr>
        <tr>
          <td
            style="font-size: 10px; text-align: start;  font-weight: bold;border-bottom: 1px solid;border-left: 1px solid; "
            colspan="3" *ngIf="taxType !== 'NO_TAX'">{{setLabel("discountedTrainerFeeLabel")}}</td>
          <td
            style="font-size: 10px; text-align: start;  font-weight: bold;border-bottom: 1px solid;border-left: 1px solid; "
            colspan="2" *ngIf="taxType === 'NO_TAX'">{{setLabel("discountedTrainerFeeLabel")}}</td>
          <td style="font-size: 10px;text-align: center; border-right: 1px solid;
                  border-bottom: 1px solid;">{{getFeeAfterTaxAndDiscount(member,"Trainer Fee - Paid")}}</td>
        </tr>
        <tr>
          <td style="font-size: 10px; text-align: start; font-weight: bold; border-left: 1px solid; border-bottom: 1px solid;"
    [attr.colspan]="hasDiscount(member.feeDetails) ? 3 : 2"
    *ngIf="taxType !== 'NO_TAX'">{{setLabel("grandTotalLabel")}}
  <i *ngIf="taxType == 'INCLUDING_TAX'" style="display: block; font-size: 10px; font-style: italic; color: blue;">
    {{setLabel("taxIncludedFeeLabel")}}
  </i>
</td>
<td style="font-size: 10px; text-align: start; font-weight: bold; border-left: 1px solid; border-bottom: 1px solid;"
    [attr.colspan]="hasDiscount(member.feeDetails) ? 2 : 1"
    *ngIf="taxType === 'NO_TAX'">{{setLabel("grandTotalLabel")}}
</td>
<td style="font-size: 10px;text-align: center; border-right: 1px solid; border-bottom: 1px solid;">
    {{getGrandTotalAfterTaxAndDiscount(member) | number:'1.0-0'}}
</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
